import { render } from "./DeletedPlaylists.vue?vue&type=template&id=79a98a6c&lang=html"
import script from "./DeletedPlaylists.vue?vue&type=script&lang=js"
export * from "./DeletedPlaylists.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__